import styled from "styled-components";

export const StyledBarCodeScannerPanel = styled.div``;